<template>
  <div class="login">
    <div class="login__wrapper">
      <div class="container">
        <form class="login__form" @submit.prevent="send">
          <img class="login__logo" src="@images/logo.png" alt="logo">
          <ui-input
              :type="'email'"
              :placeholder="'Email'"
              :rules="[isEmail]"
              v-model="email"
          />
          <ui-input
              :type="'password'"
              :placeholder="'Password'"
              :rules="[required]"
              v-model="password"
          />
          <button class="login__button" type="submit" :disabled="!isFormValid">
            Log In
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.5 7.5H14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.5 0.5L14.5 7.5L7.5 14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </form>
        <p class="login__copyright">© {{ actualYear }} STARTIFY INNOVATIVE S.R.L. All rights reserved</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {isEmail, isPasswordValid, required} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";

const email = ref('')
const password = ref('')

const actualYear = computed(() => new Date().getFullYear())

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    isPasswordValid(password.value) === true
  )
})

const send = () => {
  ElNotification({
    message: 'This account does not exist.',
    type: 'error'
  })
}
</script>

<style lang="scss" scoped>
.login {
  background-color: #252736;
  height: 100vh;

  &__header {
    padding-block: 32px;
  }

  &__logo {
    width: 375px;
    margin-bottom: 60px;
  }

  &__wrapper {
    display: grid;
    place-items: center;
  }

  &__form {
    margin-top: 200px;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-inline: auto;

    & h1 {
      color: #131313;
      text-align: center;
      font-size: 55px;
      font-weight: 700;
    }

    & p {
      font-family: Inter, sans-serif;
      color: #000;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
    }
  }

  &__button {
    cursor: pointer;
    margin-top: 45px;
    border-radius: 10px;
    background: #B8FF00;
    padding: 20px 40px;
    transition: 0.2s;
    display: flex;
    align-items: center;
    gap: 10px;

    color: #252736;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;

    @include hover {
      background: #7E52FF;
      color: #FFFFFF;
    }

    &:disabled {
      cursor: not-allowed;
      background: #B8FF00;

      @include hover {
        background: #B8FF00;
        color: #252736;
      }
    }
  }

  &__copyright {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);

    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

@media (max-width: 850px) {
  .login {
    &__form {
      margin-top: 100px;
      width: 100%;
    }
  }
}

@media (max-width: 400px) {
  .login {
    &__logo {
      width: 300px;
    }
  }
}
</style>